import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { panelArr } from "../../assets/cultivatorsEventPanels";
import structuredData from "../../assets/structuredText";
import CardsGrid from "../../components/CardsGrid";
import MarqueeText from "../../components/MarqueeText";
import usePageReset from "../../hooks/usePageReset";
import Image from "../../components/Image";

const CultivatorsHome = () => {
  usePageReset();
  const renderMarqueeText = (count: number) => {
    return Array.from({ length: count }, (_, index) => <MarqueeText key={index} />);
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="cultiv cultivators entrepreneur startup members collective company consultation networking mentorship business growth idea network global collaboration events"
        />
        <meta
          name="description"
          content="Join Cultivators forum for the latest industry insights, cross-border
networking, and empowering individuals worldwide to shape the future. Register
now!"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="image_src" itemProp="image" href="https://cultiv.llc/images/metaimg.jpg" />
        <meta
          property="og:description"
          content="Join Cultivators forum for the latest industry insights, cross-border
networking, and empowering individuals worldwide to shape the future. Register
now"
        />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Cultiv | Cultivators" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv | Cultivators" />
        <meta
          property="twitter:description"
          content="Join Cultivators forum for the latest industry insights, cross-border
networking, and empowering individuals worldwide to shape the future. Register
now!"
        />
        <meta property="twitter:image" content="https://cultiv.llc/images/metaimg.jpg" />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>Cultivators</title>
      </Helmet>
      <div className="flex flex-col h-full">
        <section className="w-full flex justify-center items-center gap-8 px-3 md:pt-20 md:pb-14 py-4 md:px-15 lg:px-20">
          <div className="flex flex-col md:text-3xl lg:text-4xl text-sm text-center items-center justify-center  px-0">
            <p className="pb-2.5 font-expandedBold">
              The Global Discussion Panel - Investing in Commercializing Universities R&D
            </p>
            <p className="font-Thin md:text-2xl text-xs md:pt-7 pt-0">Jan 15, 2024</p>
          </div>
        </section>

        <section className="bg-black text-white grid grid-cols-4 lg:grid-cols-12 gap-4 lg:gap-8 lg:bg-[url(/images/cultivators/worldmap.png)] bg-no-repeat bg-center bg-contain lg:py-32 md:px-15 lg:px-20 xl:px-30  ">
          <h2 className="md:text-5xl lg:text-4xl text-xl font-expandedBold pt-3 lg:pt-0 lg:pb-9 col-start-2 whitespace-nowrap lg:justify-self-center col-span-full">
            Our Biggest Forum Yet
          </h2>
          <Image
            src="images/cultivators/mobile-world-map.png"
            alt="world map"
            className="py-3 px-3 lg:hidden"
          />
          <div className="col-start-3 text-center  col-span-full col-end-11 px-6 md:px-10 lg:px-0 md:pb-5 lg:pb-16 pb-3 h-full">
            <p className="font-Light lg:tracking-wider xl:tracking-normal lg:text-xl  text-xs flex-grow tracking-wider md:pt-5 pt-1">
              We're going global! This year's Cultivators Forum focused on empowering individuals
              around the globe to positively impact the future through cross-border networking,
              knowledge sharing, and mentorship. Get the latest industry insights, mingle with
              fellow practitioners, and get inspired by our keynote speakers during this exciting
              forum.
            </p>
          </div>
        </section>

        <section className="flex md:py-14 py-5  md:px-15 lg:px-20 xl:px-30 px-6 items-center justify-center">
          <CardsGrid cards={panelArr} />
        </section>

        <section className="bg-black text-white flex flex-col items-center justify-center md:px-15 lg:px-20">
          <h2 className="md:text-5xl lg:text-4xl font-expandedBold text-base md:py-10 pt-5 pb-2.5 text-center">
            Ready To Attend The Next Forum?
          </h2>
          <p className="md:text-3xl lg:text-2xl text-xs font-Light">
            Let's meet in the 3rd Panel Discussion
          </p>
          <div className="flex md:gap-10 lg:gap-48 gap-6 md:text-2xl font-semibold text-sm md:pt-14 md:pb-10 py-5">
            <Link
              to={"/cultivators/register"}
              className="bg-black text-white font-Medium ease-in-out duration-300 md:w-60 w-28 h-12 border-2 hover:bg-cultiv-yellow hover:border-cultiv-yellow hover:text-black flex items-center justify-center text-xl"
            >
              Join Us
            </Link>
            <Link
              to={"/cult/cultivators"}
              className="bg-black text-white font-Medium ease-in-out duration-300 md:w-64 w-44 h-12 border-2 hover:bg-cultiv-yellow hover:border-cultiv-yellow hover:text-black flex items-center justify-center text-xl"
            >
              Meet Our Network
            </Link>
          </div>
          <div className="w-full border-y-2 md:mb-10 mb-5 overflow-hidden md:[mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)] [mask-image:_linear-gradient(to_right,transparent_0,_black_70px,_black_calc(100%-70px),transparent_100%)]">
            <div className="relative flex overflow-x-hidden overflow-y-hidden">
              <div className="animate-marquee whitespace-nowrap text-[0] leading-[0] flex items-center">
                {renderMarqueeText(15)}
              </div>
              <div className="absolute flex animate-marquee2 whitespace-nowrap text-[0] leading-[0] items-center">
                {renderMarqueeText(15)}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CultivatorsHome;
